var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "section section-yamap" }, [
    _setup.offices.wait
      ? _c("div", [_c(_setup.Dots, { staticClass: "loader" })], 1)
      : _vm._e(),
    _vm._v(" "),
    _setup.offices.list.length
      ? _c("div", { staticClass: "section-inn slova" }, [
          _c("div", { staticClass: "adr" }, [
            _setup.cur_offi.is
              ? _c("h1", [_vm._v(_vm._s(_setup.cur_offi.item.title))])
              : _vm._e(),
            _vm._v(" "),
            _setup.cur_offi.is
              ? _c("div", { staticClass: "office-info" }, [
                  _c("p", [
                    _c("strong", [_vm._v("Адрес: ")]),
                    _vm._v(_vm._s(_setup.cur_offi.item.city)),
                    _setup.cur_offi.item.address
                      ? _c("span", [
                          _vm._v(", " + _vm._s(_setup.cur_offi.item.address)),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _setup.cur_offi.item.phone
                    ? _c("p", [
                        _c("strong", [_vm._v("Телефон: ")]),
                        _vm._v(
                          _vm._s(_setup.cur_offi.item.phone) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.cur_offi.item.phone
                    ? _c("p", [
                        _c("strong", [_vm._v("E-mail: ")]),
                        _vm._v(
                          _vm._s(_setup.cur_offi.item.mail) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.cur_offi.item.info
                    ? _c("p", {
                        staticClass: "info-item pre",
                        domProps: {
                          innerHTML: _vm._s(_setup.cur_offi.item.info),
                        },
                      })
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "list" }, [
            _c(
              "div",
              { staticClass: "office-togglers" },
              _vm._l(_setup.offices.list, function (offi) {
                return _c(
                  "div",
                  {
                    key: offi.id,
                    staticClass: "office-toggler",
                    class: {
                      "office-toggler_active":
                        _setup.cur_offi.is &&
                        offi.id == _setup.cur_offi.item.id,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _setup.set_cur(offi)
                      },
                    },
                  },
                  [_vm._v(_vm._s(offi.city))]
                )
              }),
              0
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      ref: "yadiv",
      staticClass: "yadiv",
      class: {
        hidi:
          _setup.ymap.error ||
          (_setup.cur_offi.is && !_setup.cur_offi.item.latlong),
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }